import styled from 'styled-components';

import { Heading } from './Heading';

export const GradientHeader = styled(Heading)<{
  $large?: boolean;
  $purple?: boolean;
  $twoStop?: boolean;
}>`
  && {
    text-align: center;
    background-color: ${({ theme }) => theme.fontColor.LOUD};

    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;

    ${({ $purple, theme }) =>
      $purple ? theme.gradientText.LOUD : theme.gradientText.DEFAULT}
    ${({ $twoStop, theme }) =>
      $twoStop ? theme.gradientText.TWOSTOP : theme.gradientText.DEFAULT}

    span {
      display: block;
    }

    @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
      span {
        display: inline;
      }
    }
  }
`;
